import { BASE_URL } from "../config/AppConfig";
import { DOWNLOAD_SIGNED_FILE } from "../services/Endpoints";
import { DEFAULT_STATUS_CODE_SUCCESS } from "./AppConstants";

interface ISignedDocument {
  url: string;
  name: string;
}

const isApiFileUrl = (url: string): boolean => {
  try {
    const base = new URL(BASE_URL, window.location.href);
    return new URL(url, window.location.href).origin === base.origin;
  } catch {
    return false;
  }
};

const clickDownloadLink = (url: string, fileName: string) => {
  const link = window.document.createElement("a");
  link.href = url;
  link.download = fileName;
  link.rel = "noopener";
  window.document.body.appendChild(link);
  link.click();
  link.remove();
};

export const saveSignedDocument = async (
  document: ISignedDocument
): Promise<boolean> => {
  if (!isApiFileUrl(document.url)) {
    clickDownloadLink(document.url, document.name);
    return true;
  }
  const file = await DOWNLOAD_SIGNED_FILE(document.url);
  if (file?.code !== DEFAULT_STATUS_CODE_SUCCESS || !(file.response instanceof Blob)) {
    return false;
  }
  const objectUrl = URL.createObjectURL(file.response);
  clickDownloadLink(objectUrl, document.name);
  URL.revokeObjectURL(objectUrl);
  return true;
};
